import _ from 'lodash'
import {
  DATE_FORMAT,
  parseApiFormatMoment
} from '../../../../lib/MomentHelper'
import { EMPTY_VALUE } from '../../../../constants/globalTypes'

const RangeSummary = props => {
  const { range, children } = props
  let dateRange = []
  if (!_.isEmpty(range)) {
    dateRange = _.map(range, datetime => {
      return parseApiFormatMoment(datetime).format(DATE_FORMAT.UI)
    })
  }
  const [start = EMPTY_VALUE, end = EMPTY_VALUE] = dateRange
  return (
    <p>
      {`統計區間：${start} — ${end}`}
      {children}
    </p>
  )
}

export default RangeSummary
